// Frontend mirror of backend RBAC — UI convenience only; the API enforces access.
const ROLE_PERMISSIONS = {
  superadmin: ["*"],
  content_creator: ["staff", "content"],
  moderator: ["staff", "moderate"],
};

export const ROLE_LABELS = {
  superadmin: "Superadmin",
  content_creator: "Content Creator",
  moderator: "Moderator",
};

export function rolesOf(user) {
  if (user?.roles?.length) return user.roles;
  if (["admin", "superadmin"].includes(user?.role)) return ["superadmin"];
  return [];
}

export function permsFor(user) {
  const set = new Set();
  rolesOf(user).forEach((r) => (ROLE_PERMISSIONS[r] || []).forEach((p) => set.add(p)));
  return set;
}

export function can(user, perm) {
  const p = permsFor(user);
  return p.has("*") || p.has(perm);
}

export function isSuperadmin(user) {
  return rolesOf(user).includes("superadmin");
}
